import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'umlautPipe'})
export class UmlautPipe implements PipeTransform {
  transform(value: string): string {
    let umlautReady = value;
    umlautReady = umlautReady.replace(new RegExp("ae", "g"), "ä");
    umlautReady = umlautReady.replace(new RegExp("oe", "g"), "ö");
    umlautReady = umlautReady.replace(new RegExp("ue", "g"), "ü");
    umlautReady = umlautReady.replace(new RegExp("eü", "g"), "eue");
    umlautReady = umlautReady.replace(new RegExp("aü", "g"), "aue");
    umlautReady = umlautReady.replace(new RegExp("_", "g"), " ");

    return umlautReady;
  }
}
